import axios from 'src/api/Api';
import {
    GET_UNID_URL_SUCCESS,
    GET_UNID_URL_FAILURE,
} from 'src/pages/orders/redux/actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getUnidURL(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/unidurl?`;
    
    const params = convertObjectToQueryParams({
        unidCASENo: action.payload,
    });

    let finalUrl = url + `${params}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);
        yield put({ type: GET_UNID_URL_SUCCESS, payload: result.url });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload
        });
        yield put({
            type: GET_UNID_URL_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
